import { render } from "./UserLicenseManageTable.vue?vue&type=template&id=58155b46&scoped=true"
import script from "./UserLicenseManageTable.vue?vue&type=script&lang=js"
export * from "./UserLicenseManageTable.vue?vue&type=script&lang=js"

import "./UserLicenseManageTable.vue?vue&type=style&index=0&id=58155b46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58155b46"]])

export default __exports__